<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group v-if="tableDisplay" class="float-right">

        <el-button type="success" size="small" class="YeniBtn" @click="Excel"
                   icon="el-icon-download">Excel İndir
        </el-button>

      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">

          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">
            <el-col :span="8">
              <el-form-item label="Sanal Pos Hesabı" prop="Pos_id">
                <el-select v-model="Form.Pos_id" filterable clearable>
                  <el-option
                    v-for="item in PosListe"
                    :key="item.id"
                    :label="item.HesapAdi"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="Durum" prop="Durum">
                <el-select v-model="Form.Durum" filterable>
                  <el-option
                    label="Başarılı İşlem"
                    value="1">
                  </el-option>
                  <el-option
                    label="Başarısız İşlem"
                    value="2">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Rapor Tarih Aralığı" prop="Tarih">
                <el-date-picker
                  :clearable="false"
                  v-model="Form.Tarih"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Başlangıç Tarihi"
                  end-placeholder="Bitiş Tarihi"
                  format="dd.MM.yyyy"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="6">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <el-table
            v-if="tableDisplay"
            class="table-xs"
            :data="tableData"
            style="width: 100%"
            width="100%"
            :height="Height"
            show-summary
            :summary-method="TableFooter"
          >
            <el-table-column
              label="İşlem Tarihi"
              prop="Tarih"
              width="110">
            </el-table-column>
            <el-table-column
              label="Hesap"
              prop="HesapAdi">
            </el-table-column>
            <el-table-column
              label="Ad Soyad"
              prop="AdSoyad"
              width="250">
            </el-table-column>
            <el-table-column
              label="Mesaj"
              prop="Mesaj"
              width="250">
            </el-table-column>
            <el-table-column
              label="Taksit"
              prop="Taksit"
              width="50">
            </el-table-column>
            <el-table-column
              label="Firma"
              prop="Tahakkuk"
              width="75"
              align="right">
            </el-table-column>
            <el-table-column
              label="Kar"
              prop="Kar"
              width="75"
              align="right">
            </el-table-column>
            <el-table-column
              label="Aracı"
              prop="Araci"
              width="75"
              align="right">
            </el-table-column>
            <el-table-column
              label="Tutar"
              prop="Tutar"
              width="75"
              align="right">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import Yukleniyor from "../../components/Doc/Yukleniyor";

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));


export default {
  components: {Yukleniyor},
  data() {
    return {
      Height: 0,
      lo: false,
      Yetki: false,
      Kaydet: false,
      Sayfa: {
        Adi: 'Web Pos Raporu',
        ButtonAdi: 'Uygula',
        FiltreAdi: 'Filtreleme',
      },
      Form: {
        Tarih: [],
        Pos_id: null,
        Durum: "1"
      },
      FormHata: {
        Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Durum: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      MakbuzDetayModal: false,
      tableData: [],
      ExcelData: [],
      PosListe: [],
      tableDisplay: false,
      AltToplam: []
    }
  },
  methods: {
    TableFooter() {
      const sums = [];
      sums[6] = this.AltToplam.Tahakkuk;
      sums[7] = this.AltToplam.Kar;
      sums[8] = this.AltToplam.Araci;
      sums[9] = this.AltToplam.Tahsil;

      return sums;
    },
    Excel(evt) {

      const ws = XLSX.utils.json_to_sheet(this.ExcelData);
      const wb = XLSX.utils.book_new();
      ws['!cols'] = [
        {wch: 15},
        {wch: 70},
        {wch: 40},
        {wch: 20},
        {wch: 20},
        {wch: 10},
        {wch: 10},
        {wch: 10},
        {wch: 10},
        {wch: 10},
      ];

      wb.Props = {
        Title: this.Sayfa.Adi,
        Author: "Aidatim APP",
        Manager: "Aidatim APP",
        Company: "Aidatim",
        Category: "Finans",
        Keywords: "Aidatim",
        Comments: this.Sayfa.Adi,
      };
      XLSX.utils.book_append_sheet(wb, ws, this.DefterTur);
      XLSX.writeFile(wb, this.Sayfa.Adi + ".xlsx");
    },
    Yazdir() {
      window.print();
    },
    Getir() {
      this.$refs['RaporForm'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Post", {...this.Form, path: '_a/posliste'})
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.tableData = response.tableData;
                this.AltToplam = response.AltToplam;
                this.ExcelData = response.ExcelData;

                if (this.tableData)
                  this.tableDisplay = true;
                else
                  this.$message.error("Kayıt Bulunamadı");

                this.Height = window.innerHeight - 220;
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }
      })
    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: '_a/poshesap'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.PosListe = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.PosListe = [];
            this.Form.Pos_id = null;
            this.hata = response.Hata;
          }
        });
    },

  },
  created() {
    this.SayfaYukle();
    var Gun = new Date();
    //this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
    //this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    this.Form.Tarih[0] = new Date();
    this.Form.Tarih[1] = new Date();
  },

}
</script>



// WEBPACK FOOTER //
// src/pages/_a/Pos.vue